// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// this syntax is for asset pipleline, NOT for webpack starting with rails 6.x
//= require jquery3
//= require popper
//= require bootstrap-sprockets

// devise passkey
// import "devise/webauthn" dosn't work -> direct in layout/application.html.erb included

import 'bootstrap';
import "trix"

// These editors persist HTML directly in ordinary string/text model attributes.
// Attachments need separate persistence and are intentionally not accepted here.
document.addEventListener("trix-file-accept", (event) => event.preventDefault())

import Rails from "@rails/ujs"

// OLD: replaced by turbo-rails
// import Turbolinks from "turbolinks"

// The Turbo instance is automatically assigned to window.Turbo upon import:
import "@hotwired/turbo-rails"


// DISABLE Turbo inline content replacement
// import { Turbo } from "@hotwired/turbo-rails"
// Turbo.session.drive = false

// import app/javascript/controllers/*
import "controllers"

if (!window.bulkSelectionControlsInitialized) {
  window.bulkSelectionControlsInitialized = true

  const bulkSelectionCheckboxes = (form) => {
    return Array.from(form.querySelectorAll("input[type='checkbox'][name='supplier_order_item_ids[]']"))
      .filter((checkbox) => !checkbox.disabled)
  }

  const refreshBulkSelectionMaster = (form) => {
    const master = form.querySelector("[data-bulk-selection-master]")
    if (!master) return

    const checkboxes = bulkSelectionCheckboxes(form)
    const checkedCount = checkboxes.filter((checkbox) => checkbox.checked).length

    master.disabled = checkboxes.length === 0
    master.checked = checkboxes.length > 0 && checkedCount === checkboxes.length
    master.indeterminate = checkedCount > 0 && checkedCount < checkboxes.length
  }

  document.addEventListener("change", (event) => {
    const master = event.target.closest("[data-bulk-selection-master]")
    if (master) {
      const form = master.closest("form")
      if (!form) return

      bulkSelectionCheckboxes(form).forEach((checkbox) => {
        checkbox.checked = master.checked
      })
      refreshBulkSelectionMaster(form)
      return
    }

    const checkbox = event.target.closest("input[type='checkbox'][name='supplier_order_item_ids[]']")
    if (!checkbox) return

    const form = checkbox.closest("form")
    if (form) refreshBulkSelectionMaster(form)
  })
}

import * as ActiveStorage from "@rails/activestorage"
import "channels"

import "@fortawesome/fontawesome-free/js/all"
// import "@fortawesome/fontawesome-free/css/all"

import Chart from 'chart.js/auto';
// register Chart class to enable call new Chart() 
global.Chart = Chart;

Rails.start()

// OLD: replaced by turbo-rails
// Turbolinks.start()

ActiveStorage.start()
